import { render, staticRenderFns } from "./commodityCart.vue?vue&type=template&id=56bad7b0&scoped=true&"
import script from "./commodityCart.vue?vue&type=script&lang=js&"
export * from "./commodityCart.vue?vue&type=script&lang=js&"
import style0 from "./commodityCart.vue?vue&type=style&index=0&id=56bad7b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bad7b0",
  null
  
)

export default component.exports